import React, { Component } from "react";
import { ToastsContainer, ToastsContainerPosition, ToastsStore } from "react-toasts";
import { callApi } from "../../utils/api";
import QueryMailReportTable from "./QueryMailReportTable";

interface AllProps {
  match: any;
  history: any;
}

export default class QueryMailSubReport extends Component<AllProps> {
  state = {
    reports: [] as any[],
    status_id: "",
    type: "",
  };

  componentDidMount() {
    const status = this.props.match.params.id;
    const type = this.props.match.params.type;
    this.getQueryMailSubReport(status, type);
  }

  redirectToDashboard = (id: number) => {
    if (id !== undefined) {
      const status = this.state.status_id;
      const type = this.state.type;
      const url = `/query-mail-report/${type}/${status}`;
      localStorage.setItem("url", url);
      localStorage.setItem("thisPopup", JSON.stringify({ id }));
      localStorage.setItem("currentfileId", JSON.stringify(id));
      this.props.history.push("/file-dashboard/" + id);
    }
  };

  getQueryMailSubReport(status: string, type: string) {
    const { state } = this.props.history.location;
    const filterData = state && state.filterData;
    this.setState({ status_id: status, type });

    let payload: any = { status, type };
    if (filterData) payload = { ...payload, ...filterData };

    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    payload = {
      ...payload,
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };

    callApi("POST", "query_mail_subreport.php", payload)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ reports: Array.isArray(result.data) ? result.data : [] });
      })
      .catch(() => {
        ToastsStore.error("Failed to load Query Mail subreport");
        this.setState({ reports: [] });
      });
  }

  render() {
    const { reports } = this.state;
    return (
      <section className="policymain-container complaint-box">
        <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_RIGHT} />
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-header">
                          <h4>
                            <b>Received Query Via Mail Report</b>
                            <button
                              className="btn btn-primary"
                              style={{ float: "right" }}
                              onClick={() => this.props.history.goBack()}
                            >
                              Back
                            </button>
                          </h4>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="dt-responsive table-responsive">
                              <QueryMailReportTable reports={reports} redirectToDashboard={this.redirectToDashboard} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
